var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 36H96V54H102V36Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 51C62.4975 51 54.9275 49.6675 49.1825 47.25C42.615 44.485 39 40.49 39 36C39 31.51 42.6175 27.515 49.1825 24.75C54.925 22.3325 62.495 21 70.5 21C78.505 21 86.0725 22.3325 91.8175 24.75C98.385 27.515 102 31.51 102 36C102 40.49 98.3825 44.485 91.8175 47.25C86.075 49.6675 78.505 51 70.5 51ZM70.5 27C54.935 27 45 32.33 45 36C45 39.67 54.935 45 70.5 45C86.065 45 96 39.67 96 36C96 32.33 86.065 27 70.5 27Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 69C62.4975 69 54.9275 67.6675 49.1825 65.25C42.615 62.485 39 58.49 39 54V36H45V54C45 57.67 54.935 63 70.5 63C86.065 63 96 57.67 96 54H102C102 58.49 98.3825 62.485 91.8175 65.25C86.075 67.6675 78.505 69 70.5 69Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 69C44.4975 69 36.9275 67.6675 31.1825 65.25C24.615 62.485 21 58.49 21 54C21 47.4025 28.8575 41.9925 41.505 39.8825L42.4925 45.8C32.4275 47.48 26.9975 51.28 26.9975 54C26.9975 57.67 36.9325 63 52.4975 63V69H52.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84 66H78V90H84V66Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 87C44.4975 87 36.9275 85.6675 31.1825 83.25C24.615 80.485 21 76.49 21 72H27C27 75.67 36.935 81 52.5 81C68.065 81 78 75.67 78 72H84C84 76.49 80.3825 80.485 73.8175 83.25C68.075 85.6675 60.505 87 52.5 87Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 105C44.4975 105 36.9275 103.668 31.1825 101.25C24.615 98.485 21 94.49 21 90V54H27V90C27 93.67 36.935 99 52.5 99C68.065 99 78 93.67 78 90H84C84 94.49 80.3825 98.485 73.8175 101.25C68.075 103.668 60.505 105 52.5 105Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63H51V69H81V63Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.cef88489.svg";
export { ForwardRef as ReactComponent };